import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function OverviewFunnel({ entries, scale = "linear", rowGap = 0.5 }) {
  const max = Math.max(...entries.map(({ value }) => value), 1);

  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "minmax(80px, 1fr) auto minmax(80px, 1.2fr)", columnGap: 2.5, rowGap, alignItems: "center" }}>
      {entries.map(({ label, value, color, activeBackground, href }) => {
        // Both references retain a visible zero bar. Sales compresses its
        // larger count range; Recruiting uses proportional increments.
        const ratio = scale === "logarithmic"
          ? Math.log1p(value) / Math.log1p(max)
          : value / max;
        const width = 42 + 58 * ratio;
        return (
          <React.Fragment key={label}>
            <Link
              component={RouterLink}
              to={href}
              underline="hover"
              sx={{ color: "#9C4FFF", fontSize: 12, whiteSpace: "nowrap", "&:focus-visible": { outline: "2px solid #9C4FFF", outlineOffset: 2 } }}
            >
              {label}
            </Link>
            <Typography sx={{ color: "#101828", fontSize: 12, fontWeight: 700, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
              {Number(value).toLocaleString()}
            </Typography>
            <Box
              component={RouterLink}
              to={href}
              aria-label={`View ${label} pipeline`}
              sx={{
                display: "block",
                width: `${width}%`,
                height: 22,
                boxSizing: "border-box",
                border: `1px solid ${color}`,
                borderRadius: "4px",
                bgcolor: activeBackground,
                cursor: "pointer",
                "&:hover": { boxShadow: `0 0 0 1px ${color}` },
                "&:focus-visible": { outline: "2px solid #9C4FFF", outlineOffset: 2 },
              }}
            />
          </React.Fragment>
        );
      })}
    </Box>
  );
}
